import React from "react";
import "../../pages/PlanningMap/index.css";
import { MeasureDistanceMode } from "nebula.gl";

type MenuActionsProps = {
  toggleMapToolbar: () => void;
  isEnableDrawing: boolean;
  toggleDrawingMode: () => void;
  isEnableSelection: boolean;
  toggleSelectionMode: () => void;
  mapMode: any;
  toggleMeasureMode: () => void;
  gettingCurrentLocation: boolean;
  getCurrentPosition: () => void;
};

const MenuActions = ({
  toggleMapToolbar,
  isEnableDrawing,
  toggleDrawingMode,
  isEnableSelection,
  toggleSelectionMode,
  mapMode,
  toggleMeasureMode,
  getCurrentPosition,
  gettingCurrentLocation,
}: MenuActionsProps) => {
  return (
    <div className="site-planning__map-toolbar">
      <div>
        <button
          className="site-planning__map-button"
          onClick={toggleMapToolbar}
        >
          Menu
        </button>{" "}
        <button
          className={`site-planning__map-button ${
            isEnableDrawing ? "site-planning__map-button-active" : ""
          }`}
          onClick={toggleDrawingMode}
        >
          Vẽ
        </button>{" "}
        <button
          className={`site-planning__map-button ${
            isEnableSelection ? "site-planning__map-button-active" : ""
          }`}
          onClick={toggleSelectionMode}
        >
          Chọn zone
        </button>{" "}
        <button
          className={`site-planning__map-button ${
            mapMode === MeasureDistanceMode
              ? "site-planning__map-button-active"
              : ""
          }`}
          onClick={toggleMeasureMode}
        >
          Đo đạc
        </button>{" "}
        <button
          className={`site-planning__map-button ${
            mapMode === MeasureDistanceMode
              ? "site-planning__map-button-active"
              : ""
          }`}
          onClick={getCurrentPosition}
        >
          {gettingCurrentLocation ? "Đang lấy Vị trí..." : "Vị trí"}
        </button>{" "}
      </div>
    </div>
  );
};

export default MenuActions;
